import React, { useState } from "react";
import Dialog from '../../ui/Dialog';
import {
    Button, makeStyles, TextField, Typography, Grid,
    Select, MenuItem, InputLabel, Switch
} from '@material-ui/core';
import DatePicker from '../../DatePicker/DatePicker.component';
import { updateDoses } from "../../../services/Doses.service";
import LoadingOverlay from '../../LoadingOverlay/LoadingOverlay.component';
import moment from 'moment';




const UpdateDoseDetails = ({ data }) => {
    const currentDate = new Date();
    const { program_id, patient_id, status, dose_number, brand_id, dose_date,id } = data;
    const [openModal, setOpenModal] = useState(false);
    const [openConfirmation, setConfirmation] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [isLoading, setLoading] = useState(false);
    const [errorInputMessage, setErrorInputMessage] = useState(null);
    const [doseDetails, setDoseDetails] = useState({
        dose_date:moment(dose_date).format("YYYY-MM-DD") ,
        dose_number: dose_number,
        brand_id: brand_id,
        status
    });

    const onClick = async () => {
        setOpenModal(true);
    };
    const handleClose = (reload) => {
        setOpenModal(false);
        // setConfirmation(false);
        // setErrorMessage(null);

        if (reload) {
            window.location.reload();
        }
    }

    const useStyles = makeStyles(() => ({
        field: {
            marginBottom: 10,
            width: '100%',
            minWidth: '500px'
        },
        select: {
            width: '100%'
        },
        formControl: {
            width: '100%'
        },
        customWidth: {
            '& .MuiDialog-paper': {
                width: '800px',
                maxWidth: '800px',
            }
        },
        errorText: {
            color: 'red',
            fontSize: '0.75rem',
            marginTop: 3,
        }
    }));

    const classes = useStyles();

const validateForm = () => {
        const errors = {};
        let isValid = true;

        if (!doseDetails.dose_number) {
            errors.dose_number = 'Dose Number is required';
            isValid = false;
        } 


        if (!doseDetails.brand_id) {
            errors.brand_id = "Brand Id is required";
            isValid = false;
        }

        setErrorInputMessage(errors);
        return isValid;
    };

    const onSubmit = async () => {
         if (!validateForm()) {
            console.log("Form invalid");
            return;
        }

        try {
            setLoading(true);
            const payload = {
                doses: [{
                    id: id,
                    dose_date:moment(doseDetails.dose_date).format("YYYY-MM-DD") ,
                    dose_number: doseDetails.dose_number,
                    brand_id: doseDetails.brand_id,
                    status: doseDetails.status
                }]
            };
            const { result, message } = await updateDoses(
                {
                    program_id: program_id,
                    patient_id: patient_id,
                    payload
                }
            );

            if (result || message) {
                setOpenModal(false);
                setConfirmation(true);
            }
        } catch (err) {
            if (err && err.inputs && err.message === 'ValidationError') {
                setErrorInputMessage(err.inputs);
            } else if (err && err.message) {
                alert(err.message);
            }
        } finally {
            setLoading(false);
        }
    }

    const onFieldInput = (e) => {
        if (e && e.target) {
            const { name, value } = e.target;

            setDoseDetails(prevState => ({
                ...prevState,
                [name]: value,
            }));
        }
    }
    const onDateChange = (e) => {
        setDoseDetails(prevState => ({
            ...prevState,
            ['dose_date']: e,
        }));
    }

    const brandList = [
        { id: 'nucala', name: 'Nucala' },
    ];
    const formContent = (
        <>
            {/*Dose Date */}
            <Grid
                item
                container
                xs={12}
                spacing={2}
            >
                <Grid item xs={6}>
                    <InputLabel>Dose Date</InputLabel>
                    <DatePicker
                        required={true}
                        onChange={onDateChange}
                        name='dose_date'
                        className={classes.field}
                        defaultValue={currentDate}
                        value={doseDetails.dose_date}
                        // disabled
                    />
                    <Typography
                        variant='caption'
                        display='block'
                        gutterBottom
                        color='error'
                    >
                        {errorInputMessage ? errorInputMessage.dose_date : ''}
                    </Typography>
                </Grid>
            </Grid>
            {/* Dose Number */}
            <Grid item xs={12}>
                <InputLabel>Dose Number *</InputLabel>
                <TextField className={classes.field}
                    required={true}
                    name="dose_number"
                    type='number'
                   value={doseDetails.dose_number} 
                    onChange={onFieldInput}
                    // disabled
                />
                <Typography
                    variant='caption'
                    display='block'
                    gutterBottom
                    color='error'
                >
                    {errorInputMessage ? errorInputMessage.dose_number : ''}
                </Typography>

            </Grid>
            <Grid item xs={12}>
                <InputLabel>Status *</InputLabel>
                <Select
                    required
                    label='Status'
                    name="status"
                    value={doseDetails.status}
                    variant='outlined'
                    className={classes.field}
                    onChange={onFieldInput}
                // onBlur={() => handleFieldBlur('status')}
                // error={!!(touchedFields.status && errorInputMessage?.status)}
                >
                    <MenuItem value="">Select Status</MenuItem>
                    <MenuItem value="pending">Pending</MenuItem>
                    <MenuItem value="administered">administered</MenuItem>
                </Select>
                {/* {touchedFields.status && errorInputMessage?.status && (
                        <Typography className={classes.errorText}>
                          {errorInputMessage.status}
                        </Typography>
                      )} */}
            </Grid>
            {/*Brand Id */}
            <Grid item xs={12}>
                <InputLabel>Brand *</InputLabel>
                <Select
                    required
                    label="Brand"
                    name="brand_id"
                    value={doseDetails.brand_id}
                    variant="outlined"
                    className={classes.field}
                    onChange={onFieldInput}
                    // error={!!(touchedFields.brand_id && errorInputMessage?.brand_id)}
                    fullWidth
                    disabled
                >
                    {brandList.map(brand => (
                        <MenuItem key={brand.id} value={brand.id}>
                            {brand.name}
                        </MenuItem>
                    ))}
                </Select>
                {/* {touchedFields.brand_id && errorInputMessage?.brand_id && (
                                        <Typography className={classes.errorText}>
                                            {errorInputMessage.brand_id}
                                        </Typography>
                                    )} */}
            </Grid>
        </>
    )


    const formButtons = (
        <>
            <Button onClick={() => handleClose(false)} variant='contained'>
                Close
            </Button>
            <Button
                onClick={onSubmit}
                variant='contained'
                color='secondary'
                disabled={isLoading}
            >
                {isLoading ? 'Submitting...' : 'Submit'}
            </Button>
        </>
    );

    if (isLoading) {
        return <LoadingOverlay />;
    }


    return (
        <>
            <Dialog
                key='Update Doses'
                open={openModal}
                title='Update Doses'
                content={formContent}
                children={formButtons}
                onSubmit={onSubmit}
                onClose={() => handleClose(false)}
            />
            <Dialog
                key='confirmation'
                open={openConfirmation}
                title='Confirmation'
                content='Dose successfully updated!'
                children={(
                    <Button onClick={() => handleClose(true)} variant='contained'>
                        Close
                    </Button>
                )}
                onSubmit={onSubmit}
                onClose={() => handleClose(true)}
            />

            <Button variant="contained" onClick={onClick} style={{ marginRight: 8 }}>Edit</Button>
        </>
    )
}
export default UpdateDoseDetails;